import { render, staticRenderFns } from "./configuration_social_network_edit.vue?vue&type=template&id=45a0ae6f"
import script from "./configuration_social_network_edit.vue?vue&type=script&lang=js"
export * from "./configuration_social_network_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports